import {SystemBaseApi} from "./SystemBaseApi";
import {Methods} from '@newview/infrastructure';

/**
 * Api
 */
export class AuthApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'auth'
    }
    /**
     * 登录
     * @param UsrObj 登录信息
     */
     public login(UsrObj: Object) {
        return this.send(UsrObj, "login",Methods.POST);
    }
    /**
     * 公众号扫码登录
     * @param UsrObj 登录信息
     */
    public checkWechatScanLogin(openId, projectName) {
        return this.send({openId:openId, projectName: projectName}, "checkWechatScanLogin",Methods.GET);
    }
    /**
     * 监理信息化登录
     * @param UsrObj 监理信息化登录
     */
    public zJlogin(UsrObj: Object) {
        return this.send(UsrObj, "zJlogin",Methods.POST);
    }

    /**
     * 第三方授权
     * @param UsrObj
     */
    public thirdPartyGetToken(UsrObj: Object) {
        return this.send(UsrObj, "thirdPartyGetToken",Methods.POST);
    }

    /**
     * @description: 发送验证码
     * @param {*} user
     * @return {*}
     * @author: pangting
     */    
     public sendCheckCode(user){
        return this.send(user,"sendCheckCode",Methods.POST)
    }
/**
	 * @description: 发送验证码
	 * @param {*} phone
	 * @return {*}
	 * @author: pangting
	 */    
public sendkCode(phone) {
    return this.send({ userPhone: phone }, "sendCheckCode", Methods.POST)
}
    /**
	 * @description: 验证码登录
	 * @return {*}
	 */    
	public smsCodeLogin(UsrObj : Object) {
		return this.send(UsrObj, "smsCodeLogin", Methods.POST)
	}
    /**
     * @description: 忘记密码
     * @param {*} param  {newPassword:"",confirmPassWord:"",checkCode:"",phone:""}
     * @return {*}
     * @author: pangting
     */    
    public forgetPassword(param){
        return this.send(param,"forgetPassword",Methods.POST)
    }

    /**
     * 重置redisToken
     * @param id
     */
    public restRedisToken(id, token, ipAddress){
        return this.send({id: id, pcLoginToken: token, ipAddress: ipAddress},"restRedisToken",Methods.POST)
    }
    /**
     * 系统内免密登录
     * @param UsrObj 系统内免密登录
     */
    public passwordFreeLogin(UsrObj: Object) {
        return this.send(UsrObj, "passwordFreeLogin",Methods.POST);
    }
    
    public getWxCode(){
        return this.send({},"getWxCode",Methods.GET)
    }

    /**
     * 根据项目key获取二维码
     * @param params
     */
    public getWxCodeByProjectKey(params){
        return this.send(params,"getWxCodeByProjectKey",Methods.GET)
    }


    public scanCheckLogin(qrcodeTicket){
        return this.send({qrcodeTicket:qrcodeTicket},"scanCheckLogin",Methods.GET)
    }

    public getOAuthByToken(account,token){
        return this.send({account:account,token:token},"getOAuthByToken",Methods.GET)
    }

}
